import { ContactDetailPage } from '@/pages/crm/contacts/ContactDetailPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
	tab: z.enum(['history', 'meetings']).default('history'),
});

export const Route = createFileRoute('/_authenticated/_app/crm/contacts/$contactId')({
	validateSearch: searchSchema,
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['contacts.read'], redirectTo: '/dashboard' }),
	component: ContactDetailPage,
});
